import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Layout, Tabs, TabsProps, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import AccountTab from './account-tab'
import AccountByUserTab from './account-by-user-tab'
import { useLocation } from 'react-router-dom'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import AccountSetupUpload from './account-setup-upload/AccountSetupUpload'
import ErrorDetailsUpload from './account-setup-upload/ErrorDetailsUpload'
import { IResImportFile } from './account-setup-upload/useAccountSetupUpload'

export enum AccountSetTabs {
  Account = 0,
  AccountByUser = 1,
}

const AccountSetup: React.FC = () => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const [api, contextHolder] = notification.useNotification()
  const [isResetView, setIsResetView] = useState(false)
  const uploadAccountModalRef = useRef<{ openModal: Function; closeModal: Function; resetForm: Function }>()
  const errorDetailsUploadModalRef = useRef<{ openModal: Function }>()

  const handleUpload = () => {
    if (uploadAccountModalRef.current) {
      uploadAccountModalRef.current?.resetForm()
      uploadAccountModalRef.current?.openModal()
      setIsResetView(false)
    }
  }

  const handleViewErrorResults = (data: IResImportFile) => {
    if (uploadAccountModalRef.current) {
      uploadAccountModalRef.current?.closeModal()
    }

    if (errorDetailsUploadModalRef.current) {
      errorDetailsUploadModalRef.current?.openModal(data)
    }
  }

  const handleCloseErrorDetailsUpload = () => {
    if (uploadAccountModalRef.current) {
      uploadAccountModalRef.current?.openModal()
    }
  }

  const tabs: TabsProps['items'] = useMemo(() => {
    return [
      {
        key: AccountSetTabs.Account.toString(),
        label: t('AccountSetup:account_setup.account_tab_title'),
        children: <AccountTab onUpload={handleUpload} resetView={isResetView} />,
      },
      {
        key: AccountSetTabs.AccountByUser.toString(),
        label: t('AccountSetup:account_setup.account_by_user_tab_title'),
        children: <AccountByUserTab onUpload={handleUpload} resetView={isResetView} />,
      },
    ]
  }, [isResetView, t])

  useEffect(() => {
    if (state && state?.length > 0) {
      state.forEach((item: any) => {
        item.displayToast &&
          api.success({
            message: <RichTextField richText={item.accountActiveMessage} />,
          })
      })
    }
  }, [api, state])

  useEffect(() => {
    // clear location state
    window.history.replaceState({}, '')
  }, [])

  return (
    <Layout.Content
      style={{
        padding: 24,
      }}
    >
      {contextHolder}
      <Tabs defaultActiveKey={AccountSetTabs.Account.toString()} items={tabs} destroyInactiveTabPane />
      <AccountSetupUpload
        ref={uploadAccountModalRef}
        onViewErrorResults={handleViewErrorResults}
        setIsResetView={setIsResetView}
      />
      <ErrorDetailsUpload ref={errorDetailsUploadModalRef} onClose={handleCloseErrorDetailsUpload} />
    </Layout.Content>
  )
}

export default AccountSetup
